module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_eight@3x-b2c046e668ac93698d9cadb38ca5a952.webp";